import { useQuery } from "@tanstack/react-query";
import { getRebuildAPI } from "@rebuild/shared/api";
import type { LineItemXactimateMapping } from "@/interfaces/payloads/xactimate";
import { ESTIMATE_KEYS } from "./queryKeys";

const { estimatesControllerGetXactimateMappingByTemplate } = getRebuildAPI();

export function useGetXactimateMappingByTemplateQuery(estimateId: string | undefined, templateLineItemId: string | undefined) {
  return useQuery({
    queryKey: ESTIMATE_KEYS.xactimateMappingByTemplate(estimateId ?? "", templateLineItemId ?? ""),
    queryFn: async (): Promise<LineItemXactimateMapping[]> => {
      if (!templateLineItemId) {
        throw new Error("templateLineItemId is required");
      }

      const response = await estimatesControllerGetXactimateMappingByTemplate({ templateLineItemId });

      return (response.data ?? []).filter((m): m is LineItemXactimateMapping => !!m.lineItem);
    },
    enabled: !!estimateId && !!templateLineItemId,
  });
}
